var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 439.371 331.469",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145.3305,-145.3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 569.374,461.472 L 569.374,160.658 L 160.658,160.658 L 160.658,461.472 L 569.374,461.472 z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30.65500069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 164.46,164.49 L 340.78,343.158 C 353.849,356.328 377.63,356.172 390.423,343.278 L 566.622,165.928",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30.65500069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 170.515,451.566 L 305.61,313.46",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30.65500069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 557.968,449.974 L 426.515,315.375",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30.65500069
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.0a5f2a48b23ddf5bc8d316732746ca1a.svg";
export { ForwardRef as ReactComponent };